export const DEFAULT_PLAYBACK_RATES = [0.25, 0.5, 1, 1.5, 2, 3, 5] as const;

export function normalizePlaybackRate(playbackRate: number): number {
  return Number.isFinite(playbackRate) && playbackRate > 0 ? playbackRate : 1;
}

export function resolvePlaybackRateOptions(
  rates: readonly number[],
  playbackRate: number,
): Array<{ value: string; label: string }> {
  const normalizedPlaybackRate = normalizePlaybackRate(playbackRate);
  const normalizedRates = new Set(rates.filter((rate) => Number.isFinite(rate) && rate > 0));
  normalizedRates.add(normalizedPlaybackRate);

  return [...normalizedRates]
    .sort((left, right) => left - right)
    .map((rate) => ({ value: String(rate), label: `${rate}x` }));
}
